import React, { useState, useEffect } from "react"
import { defaultArea } from "@constants";
import { isEmpty, get, find } from "lodash"
import { navigate } from "@reach/router"
import Select from "react-select"
import { Col, Container, Row, Form } from "react-bootstrap"
import SearchResultInputBox from "../../predictive-search/SearchResultBox"

import {
  bedOptions,
  buildingOptions,
  priceminRange,
  pricemaxRange,
  priceminRangeRentals,
  pricemaxRangeRentals,
  radiusOptions,
  createSearchUrlFromParams,
  milesToMeter,
  getLatLan,
  isAreaMatch
} from "./constant"


// Sales & Rent

const RefineFilter = props => {
  const { searchParams, areaList } = props
  let minVal = get(searchParams, "price.min", "")
  let maxVal = get(searchParams, "price.max", "")
  const [areaVal, setAreaVal] = useState(get(searchParams, "areas", ""))
  const [minpriceVal, setMinPriceVal] = useState(minVal ? minVal : "0")
  const [maxpriceVal, setMaxPriceVal] = useState(minVal ? maxVal : "0")
  const [propertyVal, setPropertyVal] = useState(
    get(searchParams, "type", null)
  )
  const [bedVal, setBedVal] = useState(get(searchParams, "bedrooms", ""))
  const [radiusVal, setRadiusVal] = useState(get(searchParams, "radius", 0) || 3)
  const [minPriceList, setMinPriceList] = useState([])
  const [maxPriceList, setMaxPriceList] = useState([])
  const [type, setType] = useState(props.ptype)
  // const [areaList, setAreaList] = useState([])
  const [aroundLatLng, setAroundLatLng] = useState(false)
  const [moreFilter, setMoreFilter] = useState(false)

  const [configvalues, setConfigvalues] = useState({
    hitsPerPage: 200
  })
  const [sortVal, setSortVal] = useState(get(searchParams, "sortVal", ""))

  var typeList = [
    {
      value: "sales",
      label: "Buy"
    },
    {
      value: "lettings",
      label: "Rent"
    },

  ]

  if (props?.ptypetag === 'sold' || props?.ptypetag === 'let') {
    typeList = [
      {
        value: "sold",
        label: "Sold"
      },
      {
        value: "let",
        label: "Let"
      },

    ]
  }


  // Capitalize
  const capitalize = s => {
    if (typeof s !== "string") return ""
    return s.charAt(0).toUpperCase() + s.slice(1)
  }
  // Capitalize

  useEffect(() => {
    if (isEmpty(minPriceList)) {
      if (props.ptype === "lettings") {
        setMinPriceList(priceminRangeRentals)
        setMaxPriceList(pricemaxRangeRentals)
      } else {
        setMinPriceList(priceminRange)
        setMaxPriceList(pricemaxRange)
      }
    }
  }, [])

  // Update max price based on min price
  useEffect(() => {
    if (minpriceVal !== undefined && parseInt(minpriceVal)) {
      let priceItemList = pricemaxRange;
      if (props.ptype === "lettings")
        priceItemList = pricemaxRangeRentals

      setMaxPriceList(priceItemList.filter(
        x => (parseInt(x.value) > parseInt(minpriceVal) || !parseInt(x.value))
      ))
    } else {
      let priceItemList = pricemaxRange;
      if (props.ptype === "lettings")
        priceItemList = pricemaxRangeRentals
      setMaxPriceList(priceItemList)
    }
  }, [minpriceVal])

  // Update min price based on max price
  useEffect(() => {
    if (maxpriceVal !== undefined && parseInt(maxpriceVal)) {
      let priceItemList = priceminRange;
      if (props.ptype === "lettings")
        priceItemList = priceminRangeRentals
      setMinPriceList(priceItemList.filter(
        x => (parseInt(x.value) < parseInt(maxpriceVal) || !parseInt(x.value))
      ))
    } else {
      let priceItemList = priceminRange;
      if (props.ptype === "lettings")
        priceItemList = priceminRangeRentals
      setMinPriceList(priceItemList)
    }
  }, [maxpriceVal])

  useEffect(() => {
    //console.log("useEffect => ", radiusVal, areaList.length);
    if (radiusVal && areaList.length > 0) {
      let selectedArea = '';
      selectedArea = isAreaMatch(areaList, areaVal);
      let aroundLatLngTmp = aroundLatLng;
      if (!isEmpty(selectedArea)) {
        aroundLatLngTmp = getLatLan(selectedArea);
        setAroundLatLng(getLatLan(selectedArea));
      }

      if (radiusVal && !isEmpty(aroundLatLngTmp && getLatLan(selectedArea))) {

        //console.log("useEffect => 2", aroundLatLngTmp, milesToMeter(radiusVal));

        setConfigvalues({
          ...configvalues,
          aroundLatLng: aroundLatLngTmp,
          aroundRadius: milesToMeter(radiusVal),
        });
      }

      if ((!getLatLan(selectedArea) && !isEmpty(aroundLatLngTmp))) {
        setConfigvalues({
          hitsPerPage: 200
        })
      }
    }
  }, [areaList, searchParams, moreFilter])

  const onSubmit = e => {
    e.preventDefault()
    let params = {
      areas: areaVal,
      minPrice: minpriceVal,
      maxPrice: maxpriceVal,
      bedroom: bedVal,
      building: propertyVal,
      searchBaseUrl: props?.locationname,
      radius: radiusVal,
      areaList: areaList,
      sortVal: sortVal,
      // search_type: props?.searchType,
      searchBaseUrl: type == "sales" ? "/property-for-sale/" : "/property-to-rent/"
    }

    if (type === 'sold') {
      params.searchBaseUrl = (`/sell/sold-gallery/`)
    } else if (type === 'let') {
      params.searchBaseUrl = "`/landlords/let-gallery/`"
    } else if (type === 'lettings') {
      params.searchBaseUrl = "/property-to-rent/"
    } else {
      params.searchBaseUrl = "/property-for-sale/"
    }
    setMoreFilter(false)
    let url = createSearchUrlFromParams(params)
    navigate(url)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }


  let radiusAvailable = false;

  if (!isEmpty(areaList) && !isEmpty(areaVal)) {
    let sArea = isAreaMatch(areaList, areaVal);
    if (!isEmpty(sArea)) {
      radiusAvailable = true;

    }
  }

  return (
    <div className="form-wrapper-static">
      <div className="mobile-filter">
        <Form className="form-info" onSubmit={e => onSubmit(e)}>

          {moreFilter &&
            <div className="more-filter">
              <div className="head">
                <p>Refine Your Filters</p>
                <button className="close" onClick={() => { setMoreFilter(!moreFilter) }}><i className="icon-x-mark"></i></button>
              </div>

              <Form.Group className="bed-room pipe">
                <Select
                  name="type"
                  options={typeList}
                  isSearchable={false}
                  classNamePrefix={"select-opt  bedroom-select-box"}
                  value={typeList.find(
                    obj => obj.value === type
                  )}

                  onChange={e => {
                    setType(e.value)
                  }}



                />
                <i className="icon-menu-slider"></i>
              </Form.Group>
              <Form.Group className="search-box-wrapper">
                <SearchResultInputBox
                  value={areaVal.replaceAll(' ', '-') !== defaultArea.slug ? areaVal : ''}
                  setValue={setAreaVal}
                  placeHolder={`Enter your search location`}
                  areaList={areaList}
                // setList={setAreaList}
                />
                <Select
                  name="radius"
                  options={radiusOptions}
                  value={{
                    label: radiusVal
                      ? radiusOptions.filter(c => c.value == radiusVal)[0].label
                      : "Radius",
                    value: radiusVal ? radiusVal : "",
                  }}
                  placeholder="Radius"
                  classNamePrefix={"select-opt bedroom-select-box"}
                  isSearchable={false}
                  onChange={e => {
                    setRadiusVal(e.value)
                  }}
                  isDisabled={!radiusAvailable}
                />
                <i className="icon-menu-slider"></i>
              </Form.Group>
              <Form.Group className="bed-room pipe">
                <Select
                  name="minprice"
                  options={minPriceList}
                  isSearchable={false}
                  classNamePrefix={"select-opt  bedroom-select-box"}
                  defaultValue={minpriceVal || "0"}
                  value={minPriceList.find(
                    obj => obj.value === minpriceVal
                  )}
                  placeholder="Min Price"
                  onChange={e => {
                    setMinPriceVal(e.value)
                  }}



                />
                <i className="icon-menu-slider"></i>
              </Form.Group>
              <Form.Group className="bed-room pipe">
                <Select
                  name="price"
                  options={maxPriceList}
                  defaultValue={maxpriceVal || "0"}
                  value={maxPriceList.find(
                    obj => obj.value === maxpriceVal
                  )}
                  placeholder="Max Price"
                  classNamePrefix={"select-opt  bedroom-select-box"}
                  isSearchable={false}
                  onChange={e => {
                    setMaxPriceVal(e.value)
                  }}

                />
                <i className="icon-menu-slider"></i>
              </Form.Group>

              <Form.Group className="bed-room pipe">
                <Select
                  name="beds"
                  options={bedOptions}
                  value={{
                    label: bedVal
                      ? bedOptions.filter(c => c.value == bedVal)[0].label
                      : "Bedrooms",
                    value: bedVal ? bedVal : "",
                  }}
                  placeholder="Bedrooms"
                  classNamePrefix={"select-opt bedroom-select-box"}
                  isSearchable={false}
                  onChange={e => {
                    setBedVal(e.value)
                  }}
                />
                <i className="icon-menu-slider"></i>
              </Form.Group>

              <Form.Group className="building">
                <Select
                  name="building"
                  options={buildingOptions}
                  placeholder={
                    propertyVal === null || undefined || ""
                      ? "Property Type"
                      : capitalize(propertyVal).replace(/-/g, " ")
                  }
                  isSearchable={false}
                  classNamePrefix={"select-opt bedroom-select-box"}
                  value={{
                    label: propertyVal
                      ? get(buildingOptions.filter(c => c.value.toLowerCase() === propertyVal.toLowerCase()), '0.label')
                      : "Property Type",
                    value: propertyVal ? propertyVal : "",
                  }}
                  onChange={e => {
                    setPropertyVal(e.value)
                  }}
                />
                <i className="icon-menu-slider"></i>
              </Form.Group>
              <Form.Group className="building-btn">
              <button type="submit" className="btn btn-submit btn-update-submit w-100">
                  Update Results
                </button>
              </Form.Group>
            </div>
          }
          {!moreFilter &&
            <>
              <Form.Group className="search-box-wrapper">
                <SearchResultInputBox
                  value={areaVal.replaceAll(' ', '-') !== defaultArea.slug ? areaVal : ''}
                  setValue={setAreaVal}
                  placeHolder={`Enter your search location`}
                  areaList={areaList}
                // setList={setAreaList}
                />
                <Select
                  name="radius"
                  options={radiusOptions}
                  value={{
                    label: radiusVal
                      ? radiusOptions.filter(c => c.value == radiusVal)[0].label
                      : "Radius",
                    value: radiusVal ? radiusVal : "",
                  }}
                  placeholder="Radius"
                  classNamePrefix={"select-opt bedroom-select-box"}
                  isSearchable={false}
                  onChange={e => {
                    setRadiusVal(e.value)
                  }}
                  isDisabled={!radiusAvailable}
                />
                <i className="icon-menu-slider"></i>
              </Form.Group>
              <div className="filter-btns">
                <button type="button" className="btn  btn-submit btn-more-filter" onClick={() => { setMoreFilter(!moreFilter) }}>
                  <i className="icon-adjustments-horizontal"></i> Filters
                </button>
                <button type="submit" className="btn btn-submit btn-update-submit">
                  <i className="icon-magnifying-glass"></i><span className="mob_search_btn">Search</span>
                </button>
              </div>
            </>
          }
        </Form>

      </div>
    </div>
  )
}

export default RefineFilter
